export default __webpack_public_path__ + "alberta-ic-other.306a886a0cacf9ccfa97.svg";